import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW7001Model } from '../kymw7001.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 表紙特集商品選定情報確定
 * @export ConfirmFeatureGoodsByBuyerService
 * @class ConfirmFeatureGoodsByBuyerService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class ConfirmFeatureGoodsByBuyerService extends PlessJsonResponderSub<null> {
  model: KYMW7001Model;
  buyerList: string[];
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof ConfirmFeatureGoodsByBuyerService
   */
  private getBody(): PlessRequest {
    const featureInfo = {
      FeatureInfo: {
        condition: {
          OrderCode: this.model.orderCode,
          MediumType: this.model.mediumType,
          FeatureCode: this.model.featureCode,
        }
      }
    }
    const selectionGoods = {
      SelectionGoods: {
        combination: this.model.SelectionList.map(item => ({
          parameter: {
            PCode: item.pCode,
            ItemCode: item.itemCode,
            StockNum: "",
            PricePattern: item.pricePattern,
            ThisTimeSupplyPrice: item.thisTimeSupplyPrice,
            ThisTimeCostPrice: item.thisTimeCostPrice,
            PlanNum: item.planNum,
            PlanSupplyBudget: item.planSupplyBudget,
            Remarks: item.remarks
          }
        }))
      }
    }
    const selectionTarget = {
      SelectionTarget: {
        combination: this.model.SelectionTargetList.map(item => ({
          parameter: {
            PCode: item.pCode,
            ItemCode: item.itemCode,
            BuyerRequestId: item.buyerRequestId,
          }
        }))
      }
    }
    const buyerCodeList = {
      BuyerCodeList: {
        combination: this.buyerList.map(item => ({
          parameter: {
            BuyerCode: item
          } 
        }))
      }
    }
    const updateObj = {
      update:{
        FeatureInfo: featureInfo.FeatureInfo,
        SelectionGoods: selectionGoods.SelectionGoods,
        SelectionTarget: selectionTarget.SelectionTarget,
        BuyerCodeList: buyerCodeList.BuyerCodeList
      }
    }

    return new PlessRequest(updateObj);
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof ConfirmFeatureGoodsByBuyerService
   */
  execute(model: KYMW7001Model, buyerList: string[], f?: () => void): void {
    this.model = model;
    this.buyerList = buyerList;
    if (f) this.calbak = f;
    this.send('confirmFeatureGoodsByBuyer', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof ConfirmFeatureGoodsByBuyerService
   */
  success() {
    if (this.calbak) this.calbak();
  }

  /**
   * 業務エラー時のメソッド
   * @param errList サーバ受信データ
   * 機能独自の処理を行う場合、このメソッドをオーバーライドして処理を実装する。
   */
  public plessErrorHandler(errList: Object): void {
    this.dialogService.openAlertGetMessage('E0574', ['選定の確定']);
  }

  /**
   * 特殊なエラーが返ってきた場合に呼び出されるメソッド。<br/>
   * 機能独自のステータスコードを持つ場合、このメソッドをオーバーライドして処理を実装する。
   */
  public exceptionError(status: string, result: any): void {
    this.dialogService.openAlertGetMessage('E0574', ['選定の確定']);
  }
}
